import styled from 'styled-components';

export const SigningWarningStyled = styled.div`
  margin-top: 2%;
  button {
    display: none;
  }
`;
